import { createContext } from "react";

const SpinnerContext = createContext();

export default SpinnerContext;